import { httpClient, notificationApi } from "@bw/shared/api";
import type {
  NotificationBatchOutcome,
  NotificationSend,
  PlatformUserListResponse,
  Schema,
} from "@bw/shared/types/generated";

export type PlatformUser = Schema["PlatformUser"];

export interface ListRecipientsParams {
  search?: string;
  status?: string;
  limit?: number;
  offset?: number;
}

/**
 * Thin wrapper over GET /platform/users. httpClient prefixes /bff/api, so we
 * pass a backend-space path. Unset params are omitted entirely; an explicit
 * `offset=0` is preserved (0 is a real cursor position, not "unset").
 */
export async function listRecipients(
  params?: ListRecipientsParams,
): Promise<PlatformUserListResponse> {
  const sp = new URLSearchParams();
  if (params?.search) sp.set("search", params.search);
  if (params?.status) sp.set("status", params.status);
  if (params?.limit !== undefined) sp.set("limit", String(params.limit));
  if (params?.offset !== undefined) sp.set("offset", String(params.offset));
  const qs = sp.toString();
  return httpClient.get<PlatformUserListResponse>(
    `/platform/users${qs ? `?${qs}` : ""}`,
  );
}

/**
 * Broadcast a batch of notifications via the shared notification client
 * (`POST /notifications/send-batch`, canonical platform admin). The page routes the
 * fan-out through this module-owned wrapper — exactly like `listRecipients` —
 * so the send seam is fully controlled by mocking `../api`.
 */
export function sendBatch(
  payloads: readonly NotificationSend[],
): Promise<NotificationBatchOutcome> {
  return notificationApi.sendBatch(payloads as NotificationSend[]);
}
